import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { api }                             from "./services/api";
import { authApi }                         from "./services/auth";
import { timeDoctorApi }                   from "./services/time-doctor";
import { adminCompanyReducer }             from "./slices/admin/company/company";
import { authReducer }                     from "./slices/auth";
import { developersProfileReducer }        from "./slices/developer-profile/developer-profile";
import { reportsReducer }                  from "./slices/reports";
import { usersReducer }                    from "./slices/users";

const rootReducer = combineReducers({
  [api.reducerPath]          : api.reducer,
  [authApi.reducerPath]      : authApi.reducer,
  [timeDoctorApi.reducerPath]: timeDoctorApi.reducer,
  auth                       : authReducer,
  developersProfile          : developersProfileReducer,
  reportsApi                 : reportsReducer,
  users                      : usersReducer,
  adminCompany               : adminCompanyReducer,
});

export const store = configureStore({
  reducer   : rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware,
      timeDoctorApi.middleware,
      api.middleware),
  devTools: process.env.NODE_ENV === "development",
});

export const setupStore = () => store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
